/**
 * Refresh product media sliders inside Featured product after AJAX section swap (combined listings).
 * Used from VariantSelects.updateElementsAfterFetch when window.initFeaturedProduct exists.
 */
window.initFeaturedProduct = function (sectionEl) {
	if (!sectionEl?.querySelectorAll) return;

	sectionEl
		.querySelectorAll(".js-media-list, .js-media-sublist")
		.forEach((el) => {
			if (el.swiper && typeof el.swiper.destroy === "function") {
				el.swiper.destroy(true, true);
			}
		});

	subSliderInit(true, 5.5, 24);
	sliderInit(true);
	updatethumbnail();
};

document.addEventListener("DOMContentLoaded", () => {
	subSliderInit(true, 5.5, 24);
	sliderInit();
	updatethumbnail();

	document.addEventListener("shopify:section:load", function () {
		subSliderInit(true, 5.5, 24);
		sliderInit();
		updatethumbnail();
	});
});
